/*
 * Copyright (c) 2019 Hawaii Information Consortium
 * 201 Merchant St #1805, Honolulu, HI 96813
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Hawaii Information Consortium. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with HIC.
 */

import Big, { RoundingMode } from 'big.js';

export function multiplyBig(v1: any, v2: any): Big {
  return Big(v1 || 0).mul(Big(v2 || 0));
}
export function divideBig(v1: any, v2: any): Big {
  return Big(v1 || 0).div(Big(v2 || 0));
}

export const CURRENCY_ROUNDING_MODE = RoundingMode.RoundHalfEven;
